import StatusIcon from './status-icon';

export * from './status-icon';

export default StatusIcon;
